import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { loadProspects } from "src/redux/prospects/prospects.thunks";
import { ISelectedSection } from "src/redux/prospects/prospects.types";
import { selectProspects, setSelectedSection } from "src/redux/prospects/prospectsSlice";

export const useHandleProspectTab = () => {
    const { loading } = useAppSelector(selectProspects);
    const dispatch = useAppDispatch();

    const handleTabClick = (value: ISelectedSection) => {
        dispatch(setSelectedSection(value));
    }

    const loadProspectsSection = (initialized) => {
        if (initialized) {
            dispatch(loadProspects({ page: 1 }));
            return;
        }
    }

    return { handleTabClick, loadProspectsSection, loading };
};
